import { beginTask, endTask } from 'redux-nprogress';
import { loadWeeks, selectCurrent, selectWeeks } from '../../../../store/reducers/season';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { selectFormulasState } from '../../../../store/reducers/formula';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'top200';
export const selectTop200State = state => state[STORE_KEY];
export const selectTop200 = state => selectTop200State(state).currentTop200;

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  currentTop200: {},
  year: null,
  week: null,
  formulaId: 1,
  hasLoaded: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default reducer;

// ------------------------------------
// Load Cheat Sheet from api
// ------------------------------------
export const LOAD_TOP200_REQUEST = `${STORE_KEY}/LOAD_TOP200_REQUEST`;
export const LOAD_TOP200_SUCCESS = `${STORE_KEY}/LOAD_TOP200_SUCCESS`;
export const LOAD_TOP200_ERROR = `${STORE_KEY}/LOAD_TOP200_ERROR`;

export const loadTop200Request = payload => ({
  type: LOAD_TOP200_REQUEST,
  payload: { ...payload },
});
export const loadTop200Success = ({ cheatsheet }, year, week, formulaId) => ({
  type: LOAD_TOP200_SUCCESS,
  payload: { cheatsheet, year, week, formulaId },
});
export const loadTop200Error = error => ({
  type: LOAD_TOP200_ERROR,
  payload: { error },
});

actions[LOAD_TOP200_REQUEST] = (state, { payload }) => ({ ...state,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
});
actions[LOAD_TOP200_SUCCESS] = (state, { payload }) => ({ ...state,
  hasLoaded: true,
  currentTop200: payload.cheatsheet,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
});
actions[LOAD_TOP200_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});

export const loadTop200 = (year, week, formulaId) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadTop200Request(year, week, formulaId));
    const top200 = await api.cheatSheets.getByWeekTop200(year);

    return dispatch(loadTop200Success(top200, year, week, formulaId));
  } catch (error) {
    console.error(error);
    return dispatch(loadTop200Error(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View
// ------------------------------------
export const TOP200_VIEW = `${STORE_KEY}/TOP200_VIEW`;

viewNames[TOP200_VIEW] = 'Top200';
routes[TOP200_VIEW] = {
  path: '/fantasy-football-rankings-cheat-sheets/:year/top-200-standard',
  thunk: async (dispatch, getState) => {
    const state = getState();
    let { week, formulaId } = selectQuery(state);
    let { year } = state.location.payload;

    const { season: currentYear, week: currentWeek } = selectCurrent(state, 'projections');

    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;

    await dispatch(loadWeeks(year));

    if (typeof week !== 'number') {
      if (year === currentYear) {
        week = currentWeek;
      } else {
        week = selectWeeks(getState(), year, 'projections')[0];
      }
    }

    // Needs to await otherwise data won't load on SSR
    await dispatch(loadTop200(year, week, formulaId));
    await dispatch(loadToolDescriptions());
  },
};



// WEBPACK FOOTER //
// ./src/app/views/Top200/module/top200.js